export interface Affiliate {
  id: string;
  date: string;
}

export interface IsAgentAgreementActive {
  IsActive: boolean;
  NewAgentSaleNumberID: string;
}

export interface AgentDetails {
  SaleAgentNumber: string;
  AgentNumberID: string;
  AgentID: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AgentName_English: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  AgentName_Local: string;
  AgentSaleNumberName: string;
  CommissionPercentage: number;
  IsCallCenter: boolean;
}

export interface AssociationDetails {
  AssociationName: string;
  DisplaySplashScreen: boolean;
  DisplayLogo: boolean;
  LogoFile: string | null;
  AssociationDisclaimerText: string;
  DisplayDisclaimerOnWebsite: boolean;
  Result: number;
  ExceptionMessage: string | null;
  IsAssociationOneMemberOnly: boolean;
}

//TODO: Check if this is the correct type
export interface AgentQuoteDetails {
  /*customerIdentifyResponse: OtpValidationData[];
  basicQuoteResponse: CoversData;
  makeQuoteResponse: MakeQuoteApiResponseData;
  makeQuoteRequest: Partial<MakeQuoteApiRequest>;*/
  benefitRestrict: Record<string, number[]>;
}

export enum ProcessSource {
  Direct = 'direct',
  EmailQuote = 'emailquote',
  BuyNow = 'buynow',
  AbandonedCustomer = 'abandonedcart'
}
